<template>
   <v-card>
    <v-card-title>
        {{ $t('Task Information') }}
    </v-card-title>
    <v-card-text>
        <row-line :label="$t('Task status')">
          <div :class="`color-status ${task.status}`">{{ __attr(task.status) }}</div>
        </row-line>
        <row-line :label="$t('Task name')">{{ task.name }}</row-line>
        <row-line v-if="user" :label="$t('Assign to')">{{ user.name }}</row-line>
        <row-line :label="$t('Start date')">{{ dateFormat(task.start_date) }}</row-line>
        <row-line :label="$t('Due date')">
          <span :class="{ 'font-weight-bold red--text': isOverDueTask(task) }"> {{ dateFormat(task.due_date) }} </span>
        </row-line>
        <row-line :label="$t('Priority')">
          <div :class="`color-priority priority-${task.priority}`">{{ __attr(`priority.${task.priority}`) }}</div>
        </row-line>
        <row-line :label="$t('Weight')">{{ task.weight || '---' }}</row-line>
        <row-line v-if="documents && documents.length" :label="$t('Documents')">
          <div>
              <single-file-item v-for="file in documents"
              :key="`file-${file.id}`"
              :file="file"/>
          </div>
        </row-line>
        <row-line :label="$t('Task target')" >
          <div v-html="task.target"/>
        </row-line>
        <row-line :label="$t('Project name')">
            <router-link
                :to="{ name: 'projects.show', params: {id: project.id} }"
                target="_blank">
                {{ project.name }}
            </router-link>
        </row-line>
        <row-line v-if="manager" :label="$t('Project manager')">
            {{ manager.name }}
        </row-line>
        <row-line :label="$t('Created at')" :line="false">{{ utcToLocalDateTimeLess(task.created_at) }}</row-line>
    </v-card-text>
    </v-card>
</template>

<script>
import RowLine from './RowLine'
import { dateFormat, utcToLocalDateTimeLess, isOverDueTask } from '@utils'
import SingleFileItem from '@components/SingleFileItem'

export default {
  name: 'TaskBasicInfo',
  components: {
    RowLine,
    SingleFileItem
  },
  props: {
    task: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      limitTarget: true
    }
  },
  computed: {
    user() {
      return this.task.user || null
    },
    project() {
      return this.task.project || null
    },
    manager() {
      return this.task.project?.manager || null
    },
    documents() {
      return this.task.files || []
    }
  },
  methods: {
    utcToLocalDateTimeLess,
    dateFormat,
    isOverDueTask
  }
}
</script>
